import { create } from "zustand";
import ScoreService from "../API/ScoreService";

export const useScoreStore = create((set, get) => ({
    scores: {},
    setScores: (scores) => set({ scores: scores }),
    updateCommType: (siteId, type) => {
        const updateArray = (arr) => {
            return arr.map(score => score.site_id !== siteId ? score : {...score, communication_type: type})
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    updateScoreTag: (siteId, pointId, tag) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== siteId)
                    return score
                return {
                    ...score,
                    collecting_points: score.collecting_points.map(p => {
                        if (p.id !== pointId)
                            return p
                        return {...p, tag: tag}
                    })
                }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    updateIsContacted: (data) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== data.student_site_id)
                    return score
                return {
                    ...score,
                    is_contacted: data.is_contacted,
                    is_contacted_created_at: data.created_at,
                }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data)
            },
        }))
    },
    updateParentPhone: (siteId, phone) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id === siteId) 
                    return {...score, parent_phone: phone}
                return score
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data)
            },
        }))
    },
    updateComment: (siteId, classTypeId, comment) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== siteId)
                    return score
                return {
                    ...score,
                    collecting_points: score.collecting_points.map(cp => {
                        if (cp.class_type_id !== classTypeId)
                            return cp
                        return {...cp, comment: comment}
                    })
                }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    updatePoints: (email, classTypeId, points) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.email !== email)
                    return score
                return {
                    ...score,
                    collecting_points: score.collecting_points.map(cp => {
                        if (cp.class_type_id !== classTypeId)
                            return cp
                        return {...cp, points: points}
                    })
                }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    addFile: (fileType, siteId, fileData) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== siteId)
                    return score
                if (fileType === 'confirmation')
                    return {...score, confirmations: fileData}
                else if (fileType === 'scan')
                    return {...score, collecting_point_scan_works: [...score.collecting_point_scan_works, fileData]}
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    removeFile: (fileType, siteId, someId) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== siteId)
                    return score
                if (fileType === 'confirmation')
                    return {
                        ...score,
                        confirmations: score.confirmations.filter(conf => conf.id !== someId)
                    }
                else if (fileType === 'scan')
                    return {
                        ...score,
                        collecting_point_scan_works: score.collecting_point_scan_works.filter(scan => scan.scan_storage_id !== someId)
                    }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },
    updateVerifedOKK: (siteId, isChecked) => {
        const updateArray = (arr) => {
            return arr.map(score => {
                if (score.site_id !== siteId)
                    return score
                return {
                    ...score,
                    is_checked_by_qc: isChecked,
                }
            })
        }

        set(state => ({
            paginatedData: updateArray(state.paginatedData),
            scores: {
                ...state.scores,
                data: updateArray(state.scores.data),
            },
        }))
    },

    tags: [],
    fetchTags: async () => {
        if (get().tags.length < 1) {
            const response = await ScoreService.getScoresTags()
            if (response?.status === 200)
                set({ tags: response.data })
        }
    },

    filters: {
        query: '',
        classYearId: 0,
        subject: '',
        all_subjects: [],
        tagId: 0,
        sources: ['не определен', 'smart-monitoring'],
        all_sources: [],
        wrongFormat: false,
        all_cohorts: [],
        cohorts: [],
    },
    setFilters: (filters) => set({ filters: filters }),
    setFiltersFromData: (data) => {
        let all_subjects = []
        let all_sources = []
        let all_cohorts = []
        
        for (let i = 0; i < data.length; ++i) {
            const cohort = data[i]?.cohort
            if (cohort && !all_cohorts.includes(cohort))
                all_cohorts.push(cohort)

            for (let j = 0; j < data[i].collecting_points.length; ++j) {
                const subject = data[i].collecting_points[j].subject_title
                if (subject && !all_subjects.includes(subject))
                    all_subjects.push(subject)

                const source = data[i].collecting_points[j].source
                if (source && !all_sources.includes(source))
                    all_sources.push(source)
            }
        }

        if (all_sources.includes('smart-monitoring'))
            all_sources = ['не определен', 'platform', ...all_sources]
        else
            all_sources = ['не определен', 'platform', 'smart-monitoring', ...all_sources]

        all_cohorts.sort()

        set({ filters: {
            ...get().filters,
            all_subjects: all_subjects,
            all_sources: all_sources,
            all_cohorts: all_cohorts,
            cohorts: all_cohorts,
        } })
    },

    isFiltering: false,
    setIsFiltering: (isFiltering) => set({ isFiltering: isFiltering }),

    filteredData: [],
    updateFilteredData: () => {
        const filters = get().filters
        const data = get().scores.data
        let filteredData = []

        for (let i = 0; i < data.length; ++i) {
            let resultData = {...data[i]}

            let matchQuery = !filters.query
            if (filters.query) {
                const fullname = `${data[i].last_name} ${data[i].first_name}`.toLowerCase()
                if (fullname.includes(filters.query))
                    matchQuery = true

                if (data[i].site_id === Number(filters.query))
                    matchQuery = true

                if (data[i].phone.startsWith(filters.query) || data[i].phone.startsWith(filters.query, 1))
                    matchQuery = true

                if (data[i].email.startsWith(filters.query))
                    matchQuery = true
            }

            let matchClassYear = !filters.classYearId
            if (filters.classYearId) {
                if (filters.classYearId === 3)
                    matchClassYear = data[i].class_year_id === 3
                else
                    matchClassYear = data[i].class_year_id !== 3
            }

            if (filters.wrongFormat) {
                resultData.collecting_points = resultData.collecting_points.filter(
                    p => p?.tag?.title === 'другое' && !p?.comment
                )
            }

            if (filters.tagId) {
                resultData.collecting_points = resultData.collecting_points.filter(
                    p => p?.tag?.tag_id === filters.tagId
                )
            }

            if (filters.subject) {
                resultData.collecting_points = resultData.collecting_points.filter(
                    p => p?.subject_title === filters.subject
                )
            }

            if (filters.sources.length > 0) {
                resultData.collecting_points = resultData.collecting_points.filter(p => {
                    const isNotDefined = filters.sources.includes('не определен') && p.source === '' && p.points === 0
                    const isPLatform = filters.sources.includes('platform') && p.source === '' && p.points !== 0
                    const otherSources = filters.sources.filter(s => s !== 'не определен' && s !== 'platform')
                    return isNotDefined || isPLatform || otherSources.includes(p.source)
                })
            }

            const matchCohort = resultData?.cohort && filters.cohorts.includes(resultData.cohort)

            if (matchQuery && matchClassYear && matchCohort && resultData.collecting_points.length)
                filteredData.push(resultData)
        }

        set({ filteredData: filteredData })
    },

    paginatedData: [],
    setPaginatedData: (data) => set({ paginatedData: data }),
}))
